'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithExpandedLeftNav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _withSmallWindowDetected = require('./withSmallWindowDetected');

var _withSmallWindowDetected2 = _interopRequireDefault(_withSmallWindowDetected);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Prefers a user's actual expanded selection, falls back to being based on window size.
 * @param {object} props The component's props
 */
function evaluateExpandedState(_ref) {
  var requestedExpanded = _ref.requestedExpanded,
      smallWindowDetected = _ref.smallWindowDetected;

  // requestedExpanded is undefined if no user preference has been set.
  if (requestedExpanded !== undefined) {
    return requestedExpanded;
  }
  return !smallWindowDetected;
}

/**
 * This component handles converting the multiple inputs of left nav expanded state into a final
 * expanded boolean value.
 *
 * The requestedExpanded prop may be one of three values: true, false, or undefined.
 *   - If true or false, the nav is being controlled externally and that value should be
 *     preferred.
 *   - If undefined, no user preference has been set and the expand state should be set
 *     based on the window size.
 * The smallWindowDetected prop monitors window size and updates when a change is detected.
 *
 * onChangeRequestedExpandedState will be called with an object when the user clicks the expander
 *   button. This object will contain a single key (`expanded`) with one of three values:
 *   true, false, or undefined
 */

var WithExpandedLeftNav = exports.WithExpandedLeftNav = function (_Component) {
  _inherits(WithExpandedLeftNav, _Component);

  function WithExpandedLeftNav() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, WithExpandedLeftNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = WithExpandedLeftNav.__proto__ || Object.getPrototypeOf(WithExpandedLeftNav)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      expanded: evaluateExpandedState(_this.props)
    }, _this.handleExpandLeftNavClick = function () {
      var expanded = !_this.state.expanded;
      _this.setState({ expanded: expanded });

      var requestedExpanded = expanded;

      // If the user selects to expand the nav at the large screen, clear the user's
      // preference by setting it to undefined. This allows the nav to collapse
      // again if the screen shrinks.
      if (expanded && !_this.props.smallWindowDetected) {
        requestedExpanded = undefined;
      }

      _this.props.onChangeRequestedExpandedState({ requestedExpanded: requestedExpanded });

      _this.props.onChangeExpandedState({
        isExpanded: expanded,
        requestedExpanded: requestedExpanded
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithExpandedLeftNav, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // The user's preference is handled elsewhere. This only updates the
      // expanded state based on window width.
      if (nextProps.smallWindowDetected !== this.props.smallWindowDetected) {
        var expanded = evaluateExpandedState(nextProps);
        var didChange = this.state.expanded !== expanded;

        this.setState({ expanded: expanded });

        if (didChange) {
          nextProps.onChangeExpandedState({
            isExpanded: expanded,
            requestedExpanded: nextProps.requestedExpanded
          });
        }
      }
    }

    /**
     * Includes logic for updating the left nav expanded state, and updating the
     * app level component via onChangeRequestedExpandedState.
     */

  }, {
    key: 'render',
    value: function render() {
      // "consume" the props that no longer need to be passed down for proper functionality
      var passThroughProps = (0, _lodash.omit)(this.props, ['render', 'smallWindowDetected', 'onChangeExpandedState', 'onChangeRequestedExpandedState']);

      return this.props.render(_extends({}, passThroughProps, {
        expanded: this.state.expanded,
        handleExpandLeftNavClick: this.handleExpandLeftNavClick
      }));
    }
  }]);

  return WithExpandedLeftNav;
}(_react.Component);

/* istanbul ignore next */


WithExpandedLeftNav.propTypes = {
  onChangeExpandedState: _propTypes2.default.func,
  onChangeRequestedExpandedState: _propTypes2.default.func,
  render: _propTypes2.default.func.isRequired,
  // Linting tools should do better :,( This prop is being used, and needs validation.
  // eslint-disable-next-line react/no-unused-prop-types
  requestedExpanded: _propTypes2.default.bool,
  smallWindowDetected: _propTypes2.default.bool.isRequired
};
WithExpandedLeftNav.defaultProps = {
  onChangeExpandedState: _lodash.noop,
  onChangeRequestedExpandedState: _lodash.noop,
  requestedExpanded: undefined
};
var withExpandedLeftNav = function withExpandedLeftNav(WrappedComponent) {
  function RenderPropComponent(props) {
    return _react2.default.createElement(WithExpandedLeftNav, _extends({}, props, {
      render: function render(componentProps) {
        return _react2.default.createElement(WrappedComponent, componentProps);
      }
    }));
  }

  return (0, _withSmallWindowDetected2.default)(RenderPropComponent);
};

exports.default = withExpandedLeftNav;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/withExpandedLeftNav.js
// module id = 1676
// module chunks = 2